import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      width: '100%',
      // width: '16em',
      // '@media (max-height: 800px), (max-width: 1400px)': {
      //   width: '14em',
      // },
      //   border: '2px solid green',
      height: '75px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
    },
  }),
  { index: 1 },
)

export { useStyles }
